var exports = {
  "k": "x234b8571--bb54f7--container",
};

module.exports = exports;
